module.exports = __webpack_public_path__ + "static/media/clock.41111a00.svg";